import { authRoleAccess } from "auth/AuthRoleAccess";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import NextWeekOutlinedIcon from '@mui/icons-material/NextWeekOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { Settings } from "@mui/icons-material";
import ReorderIcon from '@mui/icons-material/Reorder';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import SearchIcon from '@mui/icons-material/Search';


export const navigationItems = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dashborad,
  },


  {
    title: "Case Inbox",
    icon: <NextWeekOutlinedIcon />,
    submenu: [
      {
        title: "All Cases",
        path: "/AllCases",
        roles: authRoleAccess.all_cases,
      },
      {
        title: "Forwarded Cases",
        path: "/ForwardedCases",
        roles: authRoleAccess.forwarded_cases,
      },
      {
        title: "National Case Inbox",
        path: "/NationalCases",
        roles: authRoleAccess.national_case,
      },
      {
        title: "Evidence History",
        path: "/EvidenceHistory",
        roles: authRoleAccess.case_evidence_history,
      },
      {
        title: "Our inbox",
        path: "/OrgHeadCasesManagement",
        roles: authRoleAccess.org_head_case_management,
      },
      {
        title: "Forwarded Cases",
        path: "/ForwardCases",
        roles: authRoleAccess.org_head_case_management,
      },
      {
        title: "Transfer Cases",
        path: "/TransferredCases",
        roles: authRoleAccess.org_head_case_management,
      },

      {
        title: "National Case Inbox",
        path: "/CaseManagerNationalInbox",
        roles: authRoleAccess.case_manager_cases,
      },
      {
        title: "Our inbox",
        path: "/CaseManagerAllCases",
        roles: authRoleAccess.case_manager_cases,
      },
      {
        title: "Case Approval",
        path: "/ManagerLevelsViews",
        roles: authRoleAccess.manager_levels_access,
      },
      { title: "Transfer Approvals",
        path: "/ManagerLevelsViews/transfer-approvals",
        roles: authRoleAccess.manager_levels_access,
      },
      {
        title: "Case Closure Approvals",
        path: "/ManagerLevelsViews/case-closure-approvals",
        roles: authRoleAccess.manager_levels_access,
      },
       
      { title: "Transfer Approvals",
        path: "/transfer-approvals",
        roles: authRoleAccess.transfer_approvals,
      },
       {
        title: "Case Closure Approvals",
        path: "/case-closure-approvals",
         roles: authRoleAccess.case_closure_approvals,
      },
      {
        title: "Transferring cases",
        path: "/CaseManagerCaseTransferAll",
        roles: authRoleAccess.case_manager_case_trasfer,
      },

       {
        title: "Cases",
        path: "/CaseOfficerCasesManagement",
        roles: authRoleAccess.case_officer_case_management,
      },
    ],
  },
   {
    title: "Case Reporting",
    icon: <SummarizeOutlinedIcon />,
    path: "/officer-case-reporting",
    roles: authRoleAccess.officer_case_reporting,
  },
  {
    title: "Reports",
    icon: <AssessmentOutlinedIcon />,
    path: "/reports",
    roles: authRoleAccess.reports,
  },

  {
    title: "Organizations",
    icon: <BusinessOutlinedIcon />,
    submenu: [
      {
        title: "Add New Organization",
        path: "/organizations/add",
        roles: authRoleAccess.organizations_add,
      },
      {
        title: "Existing Organization",
        path: "/organizations/existing",
        roles: authRoleAccess.organizations_existing,
      },
      {
        title: "Add Organization Admin",
        path: "/organizations/admins",
        roles: authRoleAccess.organizations_admins,
      },
      {
        title: "Organization Management",
        path: "/organizations/management",
        roles: authRoleAccess.organizations_management,
      },
    ],
  },

  {
    title: "Case Configuration",
    icon: <TuneOutlinedIcon />,
    submenu: [
      {
        title: "Case Priorities",
        path: "/Priority",
        roles: authRoleAccess.case_priority,
      },

      {
        title: "Case Categories",
        path: "/Category",
        roles: authRoleAccess.case_category,
      },

      {
        title: "Case Sub-Categories",
        path: "/SubCategory",
        roles: authRoleAccess.subcategory,
      },
      {
        title: "Social Media",
        path: "/SocialMedia",
        roles: authRoleAccess.manage_social_media,
      },

      {
        title: "Support Types",
        path: "/SupportType",
        roles: authRoleAccess.support_type_creation,
      },
      {
        title: "Suggested Organizations",
        path: "/SuggestOrganization",
        roles: authRoleAccess.suggest_organization,
      },
      {
        title: "Relationships",
        path: "/Relationship",
        roles: authRoleAccess.manage_relationship,
      },

      {
        title: "Organizations questions",
        path: "/organization_questions_setup",
        roles: authRoleAccess.case_questions_setup,
      },
      {
        title: "Suggest Designation",
        path: "/SuggestDesignation",
        roles: authRoleAccess.suggest_designation,
      },
      /* {
        title: "Case Handling Steps",
        path: "/CaseHandle",
        roles: authRoleAccess.case_handle,
      }, */
      {
        title: "Case handling steps",
        path: "/CaseHandleNew",
        roles: authRoleAccess.case_handle,
      },

    ],
  },

  {
    title: "Data Setup",
    icon: <SettingsSuggestIcon />,
    submenu: [
       {
        title: "Incident Location Types Setup",
        path: "/IncidentLocationTypes",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Incident Locations Setup",
        path: "/IncidentLocation",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Provinces Data Setup",
        path: "/ProvincesDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Districts Data Setup",
        path: "/DistrictsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Divisional Secretariats Data Setup",
        path: "/DivisionalSecretariatsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "GN Divisions Data Setup",
        path: "/GNDivisionsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "School Data Setup",
        path: "/SchoolsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Police Divisions Data Setup",
        path: "/PoliceDivisionsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Police Stations Data Setup",
        path: "/PoliceStationsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Case Close Reasons Setup",
        path: "/CaseCloseReasonsDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Complaint Mode Data Setup",
        path: "/ComplaintModeDataSetup",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Case Referred To Setup",
        path: "/CaseReferredTo",
        roles: authRoleAccess.data_setup,
      },
      {
        title: "Type of Complaint Setup",
        path: "/TypeOfComplaint",
        roles: authRoleAccess.data_setup,
      },
     
    ],
  },

    {
    title: "My Cases",
    path: "/first-respondent-case-view",
    icon: <NextWeekOutlinedIcon />,
    roles: authRoleAccess.first_respondent_case_view,
  },

    {
    title: "Reported Cases",
    path: "/first-respondent-lead-case",
    icon: <NextWeekOutlinedIcon />,
    roles: authRoleAccess.first_respondent_lead_case_view,
  },

  {
    title: "Call Center Officer Dashboard",
    path: "/CallCenterOfficer_performance_dashboard",
    icon: <EqualizerIcon />,
    roles: authRoleAccess.call_center_officer_dashboard,
  },
  {
    title: "Call Center Manager Dashboard",
    path: "/CallCenterManager_performance_dashboard",
    icon: <EqualizerIcon />,
    roles: authRoleAccess.call_center_manager_dashboard,
  },
  {
    title: "Officer Performance Dashboard",
    path: "/CaseOfficer_performance_dashboard",
    icon: <EqualizerIcon />,
    roles: authRoleAccess.case_officer_dashboard,
  },
  {
    title: "Officer Performance Dashboard",
    path: "/CaseManager_performance_dashboard",
    icon: <EqualizerIcon />,
    roles: authRoleAccess.case_manager_dashboard,
  },

    {
    title: "Perpetrator Information",
    path: "/PerpetratorInformation",
    icon: <ContactEmergencyIcon  />,
    roles: authRoleAccess.perpetrator_information,
  },
    {
      title: "Information Search View",
      path: "/InformationSearchView",
      icon: <SearchIcon />,
      roles: authRoleAccess.information_search_view,
    },

  /* {
    title: 'Documentation',
    path: '/themes/examples',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.themeExamples,
  }, */


    //Director CID
  //   {
  //   title: "Director CID National Inbox",
  //   path: "/director-cid-national-inbox",
  //   icon: <NextWeekOutlinedIcon />,
  //   roles: authRoleAccess.director_cid_national_inbox,
  // },

];